import React, { MouseEventHandler, createContext, useContext } from 'react';
import { Link } from 'react-router-dom';

import { Context } from 'components/hoc/Store';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

// https://ant.design/components/tooltip/#API
interface ITooltip extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
    link?: boolean;
    to?: string;
}

export const AnchorContext = createContext<{
    link?: boolean;
    to?: string;
    href?: string;
    anchorOnClick?: MouseEventHandler<HTMLAnchorElement> | undefined;
}>({});

const AnchorComponent: React.FC<ITooltip> = props => {
    const { serviceMode } = useContext(Context);
    const { children, link, to, onClick, ...rest } = props;
    const { navigateWorkaround } = useNavigateWorkaround();

    return (
        <AnchorContext.Provider
            value={{
                link: link,
                to: to,
                href: props.href,
                anchorOnClick: onClick
            }}
        >
            {!serviceMode ? (
                <>
                    {link ? (
                        <Link to={to || ''} onClick={onClick} {...rest}>
                            {children}
                        </Link>
                    ) : (
                        <a
                            style={props.style}
                            className={props.className}
                            href={props.href}
                            onClick={onClick}
                            {...rest}
                        >
                            {children}
                        </a>
                    )}
                </>
            ) : (
                <>
                    {(link && children.type && children.type.displayName === 'Image') ||
                    (children.type && !children.type.displayName) ? (
                        <Link to={to || ''} onClick={onClick}>
                            {children}
                        </Link>
                    ) : (
                        <a
                            style={props.style}
                            className={props.className}
                            href={
                                (children.type && children.type.displayName === 'Image') ||
                                (children.type && !children.type.displayName)
                                    ? props.href
                                    : undefined
                            }
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onClick={(e: any) => {
                                const pathElements = e.nativeEvent.composedPath() as HTMLElement[];
                                if (
                                    !pathElements?.filter(
                                        u =>
                                            typeof u.className === 'string' &&
                                            (u.className || '').includes('translateText')
                                    ).length
                                ) {
                                    onClick && onClick(e);
                                    to && navigateWorkaround(`${to}`);
                                }
                            }}
                        >
                            {children}
                        </a>
                    )}
                </>
            )}
        </AnchorContext.Provider>
    );
};

export default AnchorComponent;
